import { render, staticRenderFns } from "./LogsLabel.vue?vue&type=template&id=4d2efbb8&scoped=true"
import script from "./LogsLabel.vue?vue&type=script&lang=js"
export * from "./LogsLabel.vue?vue&type=script&lang=js"
import style0 from "./LogsLabel.vue?vue&type=style&index=0&id=4d2efbb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2efbb8",
  null
  
)

export default component.exports